import React from 'react';
 
import GalleryCard from './GalleryCard';

const galleryData = [
  {
    image: "https://img.vidflow.co/studio/cbisb64y/media/v72lcg6v/thumbc197ac2b1f49a9d47e473360f8eac6c85617221708715847.jpg?width=960&height=960&optimize=image",
    title: "Cinematography"
  },
  {
    image: "https://img.vidflow.co/studio/cbisb64y/media/v0nm8skm/thumbad76e62ce3ab9359c02629fcda1ea94728687649.jpg?width=960&height=960&optimize=image",
    title: "Kirtan"
  },
  {
    image: "https://meta.vidflow.co/studio/cbisb64y/media/04y2vk3a/thumb736fbb8136c608883bf7b9ff23cd16d8708771535.jpg?width=960&height=960&optimize=image",
    title: "LadiesSangeet"
  },
  {
    image: "https://meta.vidflow.co/studio/cbisb64y/media/n7v2ypx9/thumb6b525b6c4c018e7d42b89f4410fe8ac4116444854.jpg?width=960&height=960&optimize=image",
    title: "Preparty"
  },
  {
    image: "https://meta.vidflow.co/studio/cbisb64y/media/ahqahbmq/thumbbb42e5e4050597712b924bfb07fd4e904911295649.jpg?width=960&height=960&optimize=image",
    title: "Wedding"
  },
  {
    image: "https://meta.vidflow.co/studio/cbisb64y/media/tlshhmhg/thumb3582c5ddbfee03e76a873a71afeabb683793242.jpg?width=960&height=960&optimize=image",
    title: "Poses"
  },
  {
    image: "https://meta.vidflow.co/studio/cbisb64y/media/bmkz8sbr/thumb74276e2ea660a3362e329465f98677eb1119570141.jpg?width=960&height=960&optimize=image",
    title: "Doli & Paani Vaar"
  },
];





const deviceStyles = {
  mobile: { padding:'5px 20px' },

tablet: { paddingLeft:'20px', overflow:'hidden' },
  desktop: { paddingLeft:'40px' },
  
  }

const GallerySection = ({device}) => {
  const handlePlay = (title) => {
    alert(`Playing film for ${title}`);
  }; 

  return (
    <div id="GallerySection" className="w-full  h-full -mt-[130px]  relative   ">
      <div className="w-full h-full relative ">
        <div className="w-full   bottom-0  absolute " style={deviceStyles[device]}>
          <div className="w-full flex   min-h-[180px]  overflow-hidden box-border  gap-4  ">
            {galleryData.map((item, index) => (
              <GalleryCard
                key={index}
                image={item.image}
                title={item.title}
                device={device}

                onPlay={() => handlePlay(item.title)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GallerySection;
